export const TABLE_EXISTS_WARNING =
  "A table with this name already exists. Proceeding will delete the existing table.";

/**
 * Checks whether a Snowflake table already exists in the catalog.
 * Uses HEAD to avoid fetching the full table payload.
 */
export async function checkTableExists(schema: string, tableName: string): Promise<boolean> {
  const { VITE_CATALOG_API, VITE_CUSTOMER, MODE } = import.meta.env;
  const database = (
    MODE === "production" ? `${VITE_CUSTOMER}_prod` : `${VITE_CUSTOMER}_stage`
  ).toUpperCase();
  const fqn = `snowflake.${database}.${schema}.${tableName}`;
  const url = `${VITE_CATALOG_API}/tables/fqn/${encodeURIComponent(fqn)}`;
  try {
    const res = await fetch(url, { method: "HEAD", redirect: "manual" });
    return res.ok;
  } catch {
    return false;
  }
}
